import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import styles from './CreateCouncilMember.module.scss';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { toast } from 'react-toastify';
import { isEmpty } from 'lodash';
import { useFetchDropDownTypes } from '../../../../Hooks/Settings';
import { useFetchCouncilTeamsById } from '../../../../Hooks/Council';
import TextInput from '../../../Atoms/Inputs/TextInput';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';

const UpdateCouncilMember = () => {
  const { type, id } = useParams();
  const customizedToast = useToast();
  const fileInputRef = useRef(null);
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState('');
  const {
    data,
    isLoading,
    refetch: refetchMember,
  } = useFetchCouncilTeamsById(id);
  const { data: memberCategory } = useFetchDropDownTypes(11);
  const { data: positions } = useFetchDropDownTypes(10);

  useEffect(() => {
    if (!isEmpty(id) && id !== undefined) {
      refetchMember();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const teamData = data.data;
      formikRef.current.setValues({
        name: teamData.fullName_EN || '',
        nameAr: teamData.fullName_AR || '',
        position: teamData.positionId || '',
        category: teamData.categoryId || '',
      });
      setImageSrc(
        sanitizeAndValidateUrl(`${data?.data?.url}${data?.data?.teamImage}`)
      );
    }
  }, [data]);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    nameAr: Yup.string().required('Arabic name is required'),
    position: Yup.string().required('Position is required'),
    category: Yup.string().required('Category is required'),
    image:
      !isEmpty(id) && undefined !== id
        ? Yup.mixed().notRequired()
        : Yup.mixed().required('Image is required'),
  });

  const createMember = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Council/CouncilTeams`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      customizedToast.open(
        id ? 'تم تحديث عضو المجلس بنجاح' : 'تم إنشاء عضو المجلس بنجاح'
      );
      setTimeout(() => {
        formikRef.current.resetForm();

        navigate(
          `/home/council/${
            type == 0
              ? 'students'
              : type == 1
              ? 'parents'
              : type == 2
              ? 'cadets-students'
              : type == 3
              ? 'faculty-members'
              : 'council-calendar'
          }`,
          {
            state: { selectedActivity: false },
          }
        );
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('FullName_EN', values.name);
    formData.append('FullName_AR', values.nameAr);
    if (undefined !== values.image) {
      formData.append('TeamImage', values.image);
    }
    const teamId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('CouncilTeamId', teamId);
    formData.append('CategoryId', values.category);
    formData.append('PositionId', values.position);
    formData.append('CouncilType', type);
    createMember.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={id ? 'تعديل العضو' : 'إضافة عضو جديد'}
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            name: data?.data.fullName_EN || '',
            nameAr: data?.data.fullName_AR || '',
            position: data?.data.positionId || '',
            category: data?.data.categoryId || '',
            image: null,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <div className={styles['steps']}>
                <div className={styles['step-container']}>
                  <TextInput
                    label='Name'
                    placeholder='Enter Name'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.name}
                    touched={touched.name}
                    value={values.name}
                    name='name'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                  <CustomSelect
                    label='Position'
                    placeholder='Select Position'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ height: '62px', marginTop: '4px' }}
                    value={values.position}
                    onChange={(e) => setFieldValue('position', e.value)}
                    options={positions?.data?.map((option) => ({
                      value: option.value,
                      text: option.text_EN,
                    }))}
                    type='council'
                    errors={errors.position}
                    touched={touched.position}
                  />
                </div>
                <div className={`${styles['step-container']} ${styles['rtl']}`}>
                  <TextInput
                    label='الاسم'
                    placeholder='أدخل الاسم'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                      marginBottom: '26px',
                    }}
                    containerStyle={{
                      padding: '0px',
                      justifyContent: 'flex-start',
                    }}
                    name='nameAr'
                    value={values.nameAr}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    onChange={(name, value) => setFieldValue(name, value)}
                  />
                </div>
                <div
                  className={styles['step-container']}
                  style={{ marginTop: '26px' }}
                >
                  <CustomSelect
                    label='Member Category'
                    placeholder='Select Category'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ height: '62px', marginTop: '4px' }}
                    value={values.category}
                    onChange={(e) => setFieldValue('category', e.value)}
                    options={memberCategory?.data?.map((option) => ({
                      value: option.value,
                      text: option.text_EN,
                    }))}
                    type='council'
                    errors={errors.category}
                    touched={touched.category}
                  />
                </div>
              </div>
              {errors.image && touched.image && (
                <div className={styles['error-message']}>
                  <p>{errors.image}</p>
                </div>
              )}
              <div style={{ marginTop: '30px' }}>
                <label>رفع الصورة</label>
              </div>
              <div
                className={styles['upload-container']}
                onClick={() => fileInputRef.current.click()}
              >
                <input
                  type='file'
                  accept='image/*'
                  className='form-control form-body-input'
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={(event) =>
                    setFieldValue('image', event.currentTarget.files[0])
                  }
                />
                {values.image ? (
                  <img
                    className={styles['uploaded-image']}
                    src={URL.createObjectURL(values.image)}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : imageSrc ? (
                  <img
                    className={styles['uploaded-image']}
                    src={imageSrc}
                    alt='selected-image'
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = noImageFound;
                    }}
                  />
                ) : (
                  <div className={styles['upload-icon-container']}>
                    <img className={styles['upload-icon']} src={uploadIcon} />
                    <div className={styles['text-container']}>
                      <p className={styles['select-image']}>
                        Select Image to Upload
                      </p>
                      <p className={styles['size']}>max size: 100MB</p>
                    </div>
                  </div>
                )}
              </div>
              <button
                type='submit'
                className={styles['submit-button']}
                style={{ display: 'none' }}
              >
                Submit
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default UpdateCouncilMember;
